export const REGEX = {
  FULL_NAME: /^[a-zA-Z]{3,} ([a-zA-Z] ?)*[a-zA-Z]{3,}$/,
  PEROSN_NAME: /^[a-zA-Z ]{3,}$/,
  PHONE_NUMBER: /^\d{1,11}$/,
};
